<template>
  <section class="closefriend-hero h-100">
    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>
    <customer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></customer-menu>
    <header-menu @slideMenu="slideBar()" :is-loading="isLoading"></header-menu>

    <div class="container-fluid mt-3">
      <div class="row justify-content-center">
        <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <global-message />

          <div class="login-card mx-auto mb-3 p-3 p-md-4 mt-2">
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-2">
              <div>
                <h5 class="text-white font-weight-700 mb-0 font-size-20">Messages</h5>
                <span class="text-muted font-size-12">{{ creators.length }} conversations</span>
              </div>
              
              <div class="position-relative" style="width: 100%; max-width: 260px;">
                <i class="fa fa-search position-absolute text-muted" style="left: 12px; top: 10px;"></i>
                <input type="text" class="w-100 font-size-13" style="padding-left: 36px; padding-right: 32px; padding-top: 8px; padding-bottom: 8px; border-radius: 20px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); color: #fff; transition: all 0.2s ease; outline: none;" 
                       placeholder="Search creators..." v-model="searchQuery"
                       onfocus="this.style.borderColor='rgba(255,255,255,0.3)'; this.style.background='rgba(255,255,255,0.08)';"
                       onblur="this.style.borderColor='rgba(255,255,255,0.1)'; this.style.background='rgba(255,255,255,0.05)';">
                <span v-if="searchQuery" class="position-absolute cursor-pointer text-muted font-size-16" style="right: 12px; top: 8px;" @click="searchQuery = ''">&times;</span>
              </div>
            </div>
            
            <div v-if="isLoading" class="py-4">
              <div v-for="i in 4" :key="i" class="msg-inbox-row d-flex align-items-center mb-2" style="border-color: rgba(255,255,255,0.05); cursor: default;">
                <div class="me-3 flex-shrink-0" style="width: 48px; height: 48px; border-radius: 50%; background: rgba(255,255,255,0.05); animation: pulse 1.5s infinite;"></div>
                <div class="flex-grow-1">
                  <div style="height: 14px; background: rgba(255,255,255,0.08); width: 30%; border-radius: 4px; margin-bottom: 8px; animation: pulse 1.5s infinite;"></div>
                  <div style="height: 12px; background: rgba(255,255,255,0.04); width: 60%; border-radius: 4px; animation: pulse 1.5s infinite;"></div>
                </div>
              </div>
            </div>
            
            <div v-else-if="creators.length === 0" class="text-center py-5">
              <div class="stella-empty-state-icon mb-3">
                <i class="fa fa-envelope font-size-22" style="opacity: 0.4; color: #E53BB9;"></i>
              </div>
              <h5 class="text-white font-weight-500 mb-2" style="opacity: 0.6;">No messages yet</h5>
              <p class="text-white font-size-14 mb-0" style="opacity: 0.35;">
                Messages from your creators will appear here.
              </p>
            </div>

            <div v-else>
              <div 
                v-for="(creator, index) in filteredCreators" :key="index"
                class="msg-inbox-row cursor-pointer"
                :class="{ 'unread-thread': isUnread(creator) }"
                @click="openDirectMessage(creator.id)">
                <div class="d-flex align-items-center" style="min-width: 0;">
                  <div class="position-relative me-3 flex-shrink-0">
                    <message-avatar :user-id="creator.id"/>
                    <span v-if="isUnread(creator)" class="msg-unread-dot-badge position-absolute"></span>
                  </div>
                  <div class="flex-grow-1" style="min-width: 0;">
                    <div class="d-flex align-items-center justify-content-between">
                      <span class="font-size-14 text-truncate" 
                            :class="isUnread(creator) ? 'text-white font-weight-700' : 'text-white font-weight-500'" 
                            :title="creator.name ? creator.name : creator.email">
                        {{ creator.name ? creator.name : creator.email }}
                      </span>
                      <span class="font-size-12 ms-2 flex-shrink-0" 
                            :class="isUnread(creator) ? 'text-white font-weight-600' : 'text-muted'" 
                            v-if="creator.lastChat">
                        {{ timeSince(creator.lastChat.sentAt) }}
                      </span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between mt-1" v-if="creator.lastChat">
                      <p class="font-size-12 mb-0 message-preview text-truncate" 
                         :class="isUnread(creator) ? 'text-white font-weight-500' : 'text-muted'" 
                         :title="creator.lastChat.message"
                         :style="isUnread(creator) ? 'opacity: 0.9;' : ''">
                        {{ cropMessage(creator.lastChat) }}
                      </p>
                      <span v-if="isUnread(creator)" class="msg-unread-badge ms-2">
                        {{ (creator.unreadCount && creator.unreadCount > 0) ? creator.unreadCount : '1' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import CustomerMenu from "@/components/module/customer/shared/CustomerMenu";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import MessageAvatar from "@/components/module/shared/direct-message/MessageAvatar";
import { httpMixin } from "@/mixin/http-mixin";
import { mapGetters } from "vuex";
import { SERVICE_DIRECT_MESSAGE } from "@/properties/micro-service";
import { timeSince } from "@/common/datetime-service";
import CustomerPwaActionBar from "@/components/module/customer/shared/CustomerPwaActionBar";
import { cropMessage } from "@/common/Utils";


import '@/assets/styles/direct-message/direct-message-common.css';

export default {
  name: "CustomerMessageDashboard",
  mixins: [httpMixin],
  components: {
    HeaderMenu,
    CustomerMenu,
    GlobalMessage,
    MessageAvatar,
    CustomerPwaActionBar
  },
  data() {
    return {
      showSlideBar: false,
      creators: [],
      inboxCount: 0,
      isLoading: true,
      searchQuery: ''
    };
  },
  computed: {
    ...mapGetters(['getUser']),
    filteredCreators() {
      if (!this.searchQuery) return this.creators;
      let q = this.searchQuery.toLowerCase();
      return this.creators.filter(c => {
        let n = c.name ? c.name.toLowerCase() : '';
        let e = c.email ? c.email.toLowerCase() : '';
        return n.includes(q) || e.includes(q);
      });
    }
  },
  watch: {
    getUser: {
      immediate: true,
      handler(user) {
        if (user && user.id) {
          if (!this.creators || this.creators.length === 0) {
            this.getCreators();
          }
        }
      }
    }
  },
  created() {
    if (this.getUser && this.getUser.id) {
      this.getCreators();
    }
  },
  methods: {
    timeSince,
    cropMessage,
    isUnread(creator) {
      if (!creator) return false;
      if (creator.unreadCount && creator.unreadCount > 0) return true;
      const currentUserId = this.getUser ? this.getUser.id : null;
      return !!(creator.lastChat && (!creator.lastChat.read && creator.lastChat.senderId !== currentUserId));
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },
    getCreators() {
      if (!this.getUser || !this.getUser.id) {
        this.isLoading = false;
        return;
      }
      this.isLoading = true;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/customers/${this.getUser.id}/senders`;
      this.getData(url, (creators) => {
        this.creators = creators || [];
        if (this.creators.length > 0) {
          this.getCreatorsLatestMessage();
        } else {
          this.isLoading = false;
        }
      }, () => {
        this.isLoading = false;
      });
    },
    getCreatorsLatestMessage() {
      if (!this.getUser || !this.getUser.id) {
        this.isLoading = false;
        return;
      }
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/customers/${this.getUser.id}/latest`;
      this.getData(url, (lastChatData) => {
        let lastChats = lastChatData.chatMessages ? lastChatData.chatMessages : [];
        this.inboxCount = lastChatData.unreadMessageCount;
        lastChats.forEach((lastChat) => {
          let index = this.creators.findIndex((sub) => sub.id === lastChat.senderId || sub.id === lastChat.receiverId);
          if (index !== -1) {
            let creator = this.creators[index];
            creator.lastChat = lastChat;
            if (!creator.unreadCount) creator.unreadCount = 0;
            const currentUserId = this.getUser ? this.getUser.id : null;
            if (!lastChat.read && currentUserId && lastChat.senderId !== currentUserId) {
              creator.unreadCount = 1;
              this.fetchUnreadCountForThread(creator, index);
            }
            this.$set(this.creators, index, creator);
          }
        });
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      }, true);
    },
    openDirectMessage(creatorId) {
      if (creatorId) {
        localStorage.setItem('selectedCreatorId', creatorId);
      }
      this.$router.push({ name: 'CustomerDirectMessage', params: { customerId: creatorId } });
    },
    fetchUnreadCountForThread(creator, index) {
      if (!this.getUser || !this.getUser.id) return;
      const url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/customers/${this.getUser.id}/receiver/${creator.id}`;
      this.getData(url, (messages) => {
        if (!messages || !Array.isArray(messages)) return;
        const currentUserId = this.getUser ? this.getUser.id : null;
        const count = messages.filter(m => !m.read && m.senderId !== currentUserId).length;
        if (count > 0) {
          creator.unreadCount = count;
          this.$set(this.creators, index, creator);
        }
      }, () => {
        // Silently catch thread fetch error so UI never breaks
      }, true);
    }
  }
};
</script>

<style scoped>
.msg-inbox-row {
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 12px;
  padding: 16px !important;
  margin-bottom: 12px !important;
  background: rgba(255, 255, 255, 0.02);
  transition: all 0.2s ease;
}
.msg-inbox-row:hover {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}
.msg-inbox-row.unread-thread {
  background: rgba(229, 59, 185, 0.08) !important;
  border-color: rgba(229, 59, 185, 0.4) !important;
  box-shadow: inset 3px 0 0 #E53BB9, 0 2px 12px rgba(229, 59, 185, 0.12);
}
.msg-inbox-row.unread-thread:hover {
  background: rgba(229, 59, 185, 0.12) !important;
  border-color: rgba(229, 59, 185, 0.6) !important;
}
.msg-unread-dot-badge {
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #F3DA6B, #E53BB9);
  border: 2px solid #111;
  box-shadow: 0 0 8px rgba(229, 59, 185, 0.8);
}
.msg-unread-badge {
  background: linear-gradient(135deg, #E53BB9, #ff6ec7);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 12px;
  min-width: 20px;
  text-align: center;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(229, 59, 185, 0.4);
}
</style>
